<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商户停车卡</el-breadcrumb-item>
      <el-breadcrumb-item>导入记录查询</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row>
        <el-col :span="4">
          <el-date-picker v-model="queryInfo.queryStartDate" type="date" placeholder="查询日期起"></el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-date-picker v-model="queryInfo.queryEndDate" type="date" placeholder="查询日期止"></el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="getImpHistory1">查&nbsp;&nbsp;询</el-button>
        </el-col>
      </el-row>

      <el-table border stripe :data="dataList">
        <el-table-column type="index"></el-table-column>
        <el-table-column label="导入日期" width="180px">
          <template slot-scope="scope">{{scope.row.optTime | dateFormat}}</template>
        </el-table-column>
        <el-table-column label="导入总数" prop="totalImports"></el-table-column>
        <el-table-column label="导入成功数" prop="successImports"></el-table-column>
        <el-table-column label="导入失败数" prop="failImports"></el-table-column>
        <el-table-column label="导入失败手机号码" prop="failPhones" width="550px"></el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 50]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
import { getMonthStart, getMonthEnd, dateFormat } from '@/utils/utils'
export default {
  created () {
    // 页面初始化
    this.initPage()
  },
  data () {
    return {
      token: '', // token存页面
      merchantId: '', // 商户ID
      dataList: [], // 查询列表数据
      total: 0, // 查询数据总条数
      queryInfo: { // 查询条件
        queryStartDate: getMonthStart(),
        queryEndDate: getMonthEnd(),
        pagenum: 1,
        pagesize: 10
      }
    }
  },
  methods: {
    // 页面初始化
    initPage () {
      const token = window.sessionStorage.getItem('token')
      if (undefined === token || token === '') { // 判断用户登录是否有效
        this.$message.error('您的登录已失效，请重新登录')
        window.sessionStorage.clear()
        this.$router.push('/login')
      }
      this.token = token
      // 获取merchantId
      const merchantId = window.sessionStorage.getItem('merchantId')
      if (undefined === merchantId || merchantId === '') { // 判断merchantId是否存在
        this.$message.error('您的登录已失效，请重新登录')
        window.sessionStorage.clear()
        this.$router.push('/login')
      }
      this.merchantId = merchantId
      // 初始化查询
      this.getImpHistory1()
    },

    // 查询按钮
    getImpHistory1 () {
      this.queryInfo.pagenum = 1
      this.getImpHistory()
    },

    // 停车卡导入历史查询（异步）
    getImpHistory () {
      // 处理日期查询条件
      let startDateStr = null
      let endDateStr = null
      if (this.queryInfo.queryStartDate !== null) {
        startDateStr = dateFormat(this.queryInfo.queryStartDate) + ' 00:00:00'
      }
      if (this.queryInfo.queryEndDate !== null) {
        endDateStr = dateFormat(this.queryInfo.queryEndDate) + ' 23:59:59'
      }
      // 查询列表
      this.$http.get('queryimportCardsHistory', {
        headers: { token: this.token },
        params: {
          // 查询参数
          pagenum: this.queryInfo.pagenum,
          pagesize: this.queryInfo.pagesize,
          queryStartDate: startDateStr,
          queryEndDate: endDateStr,
          merchantId: this.merchantId
        }
      }).then(result => {
        const res = result.data
        this.dataList = res.rows
        this.total = res.total
      })
    },

    // 监听pagesize改变
    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getCardsList()
    },

    // 当前页码改变
    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.getCardsList()
    }
  },
  computed: {}
}
</script>

<style lang="less" scoped>
.el-col {
  margin: 7px 7px 7px 7px;
}
</style>
